// Duck-types the AxiosError shape (ErrorType<Error> = AxiosError) to read the HTTP
// status without depending on axios or the `api` package. Returns undefined when there
// is no numeric status (e.g. network failures).
export const getErrorStatus = (error: unknown): number | undefined => {
  if (typeof error !== 'object' || error === null) {
    return undefined;
  }

  const err = error as { response?: { status?: unknown }; status?: unknown };

  if (typeof err.response?.status === 'number') {
    return err.response.status;
  }

  if (typeof err.status === 'number') {
    return err.status;
  }

  return undefined;
};
